import { getProcedureRoute } from "@mx/gpl-common";
import format from "date-fns/format";
import Link from "next/link";
import { IProcedure } from "../../typings/filterEntities";
import FeaturedTag from "../FeaturedTag/FeaturedTag";
import Heading from "../Heading/Heading";
import { AvatarPlaceholderIcon, industryIconMap } from "../Icons/Icons";
import styles from "./ProcedureCardWide.module.css";

interface IProps {
  procedure: IProcedure;
}

export default function ProcedureCardWide({ procedure }: IProps) {
  const { listingDate, isFeatured, industry, maintainer, topic, title, uid } = procedure;

  const IndustryIcon = industryIconMap[industry.slug];
  const formattedDate = format(new Date(listingDate), "P");

  return (
    <Link href={getProcedureRoute(uid, title)} className={styles.root}>
      <div className={styles.left}>
        <Heading component="h4" variant="h4">
          {title}
        </Heading>
        <div className={styles.maintainerName}>
          <div className={styles.maintainerImageWrapper}>
            {maintainer?.thumbnail.originalUrl ? (
              <img
                className={styles.maintainerImage}
                src={maintainer?.thumbnail.originalUrl}
                width={16}
                height={16}
              />
            ) : (
              <AvatarPlaceholderIcon width={16} height={16} />
            )}
          </div>
          {maintainer?.name}
        </div>
      </div>
      <div className={styles.right}>
        <div className={styles.taxonomies}>
          {IndustryIcon && <IndustryIcon width={14} height={14} />} {industry.label} • {topic.label}
        </div>
        <div className={styles.meta}>
          <div>{formattedDate}</div>
          {!!isFeatured && (
            <div className={styles.featured}>
              <FeaturedTag />
            </div>
          )}
        </div>
      </div>
    </Link>
  );
}
